export const GET_PAYWALL_REQUEST_LIST = '[PAYWALL][GET] request list';
// export const RESET_LOBBY_MESSAGE_LIST = '[LOBBY MESSAGE][reset] Reset Lobby List';
export const GET_PAYWALL_REQUEST_LOGS = '[PAYWALL REQUEST LOG]Get paywall request table list';
export const GET_PAYWALL_REQUEST_LOGS_FAILURE = '[PAYWALL REQUEST LOG FAILURE]Get paywall request table list Failure';
